<template>
  <div class="compressed-content">
    <h3 class="page-question">Are you taking any of the following to manage your triglycerides?<br /><i>(Check all that apply)</i></h3>
    <v-form-group class="card-selector page-buttons" :validator="$v.triglycerides">
      <b-form-checkbox v-model="survey.bloodBiochemistry.triglycerides.isNotTakingAnything"
                       @change="onNoneSelected">
        None
      </b-form-checkbox>
      <b-form-checkbox v-model="survey.bloodBiochemistry.triglycerides.isTakingFishOilPrescription"
                       @change="onFishOilPrescriptionSelected">
        Prescription fish oil (examples include lovaza, omega-3-acid ethyl esters, Omtryg, epanova)
      </b-form-checkbox>
      <b-form-checkbox v-model="survey.bloodBiochemistry.triglycerides.isTakingFishOilSupplement"
                       @change="onFishOilSupplementSelected">
        Fish oil supplement
      </b-form-checkbox>
      <b-form-checkbox v-model="survey.bloodBiochemistry.triglycerides.isTakingVascepaPrescription"
                       @change="onVascepaSelected">
        Prescription Vascepa
      </b-form-checkbox>
    </v-form-group>
  </div>
</template>

<script>
  import formMixin from "mixins/form-mixin";
  import { createNamespacedHelpers } from 'vuex';
  const { mapState } = createNamespacedHelpers('survey');
  import { anyOptionRequired } from 'utils/custom-validators';

  export default {
    mixins: [formMixin],

    validations: {
      triglycerides: {
        anyOptionRequired: anyOptionRequired((value) => value.isNotTakingAnything || value.isTakingFishOilPrescription
          || value.isTakingFishOilSupplement || value.isTakingVascepaPrescription)
      }
    },

    computed: {
      ...mapState(["survey"]),

      triglycerides() { return this.survey.bloodBiochemistry.triglycerides; }
    },

    methods: {
      onNoneSelected(value) {
        this.setOptions(value, false, false, false);
      },

      onFishOilPrescriptionSelected(value) {
        this.setOptions(false, value, this.triglycerides.isTakingFishOilSupplement,
          this.triglycerides.isTakingVascepaPrescription);
      },

      onFishOilSupplementSelected(value) {
        this.setOptions(false, this.triglycerides.isTakingFishOilPrescription, value,
          this.triglycerides.isTakingVascepaPrescription);
      },

      onVascepaSelected(value) {
        this.setOptions(false, this.triglycerides.isTakingFishOilPrescription,
          this.triglycerides.isTakingFishOilSupplement, value);
      },

      setOptions(isNotTakingAnything, isTakingFishOilPrescription, isTakingFishOilSupplement, isTakingVascepaPrescription) {
        this.survey.bloodBiochemistry.triglycerides.isNotTakingAnything = isNotTakingAnything;
        this.survey.bloodBiochemistry.triglycerides.isTakingFishOilPrescription = isTakingFishOilPrescription;
        this.survey.bloodBiochemistry.triglycerides.isTakingFishOilSupplement = isTakingFishOilSupplement;
        this.survey.bloodBiochemistry.triglycerides.isTakingVascepaPrescription = isTakingVascepaPrescription;
      }
    }
  };
</script>